import logo from '../assets/logo.png';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo" data-testid="logo-link" onClick={closeMenu}>
            <img 
              src={logo}
              alt="Intlrr Logo"
              className="logo-img"
            />
          </Link>
          
          <div className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
            <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
            <Link to="/programs" className="nav-link" onClick={closeMenu}>Programs</Link>
            <Link to="/mentorship" className="nav-link" onClick={closeMenu}>Mentorship</Link>
            <Link to="/CampusConnect" className="nav-link" onClick={closeMenu}>CampusConnect</Link>
            <Link to="/resources" className="nav-link" onClick={closeMenu}>Resources</Link>
            <Link to="/testimonials" className="nav-link" onClick={closeMenu}>Testimonials</Link>
            <Link to="/about" className="nav-link" onClick={closeMenu}>About</Link>
            <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact</Link>
          </div>

          <div className="nav-actions">
            <a
              href="https://rzp.io/rzp/cGHJ7TZk"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary header-cta"
              data-testid="apply-now-btn"
            >
              Enroll Now (Live Project)
            </a>
            <button className="mobile-menu-toggle" onClick={toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </nav>
      </div>

      <style jsx>{`
        .header {
          background: var(--background);
          border-bottom: 1px solid var(--border);
          position: sticky;
          top: 0;
          z-index: 1000;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }

        .nav {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 0;
        }

        .logo-img {
          height: 140px;
          width: auto;
        }

        .nav-menu {
          display: flex;
          align-items: center;
          gap: 2rem;
        }

        .nav-link {
          color: var(--text-primary);
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s ease;
        }

        .nav-link:hover {
          color: var(--secondary);
        }
         .header-cta {
  white-space: nowrap;
  margin-left: 1.5rem;
}
.logo {
  margin-right: 2.5rem;
}
.logo {
  flex-shrink: 0;
}



        .nav-actions {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .mobile-menu-toggle {
          display: none;
          flex-direction: column;
          background: none;
          border: none;
          cursor: pointer;
          gap: 3px;
        }

        .mobile-menu-toggle span {
          width: 24px;
          height: 3px;
          background: var(--text-primary);
          border-radius: 2px;
          transition: all 0.2s ease;
        }

        @media (max-width: 768px) {
          .nav-menu {
            position: fixed;
            overflow-x: hidden;      /* IMPORTANT FIX */
            top: 0;
            right: -100%;
            width: 300px;
            height: 100vh;
            background: var(--background);
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 6rem 2rem 2rem;
            gap: 1.5rem;
            transition: right 0.3s ease;
            box-shadow: var(--shadow-xl);
            border-left: 1px solid var(--border);
          }

          .nav-menu-open {
            right: 0;
          }

          .mobile-menu-toggle {
            display: flex;
          }

          .nav-actions .btn {
            display: none;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
